import React from "react";
import logo from "../assets/logobb.png";
import building from "../assets/building.svg";
import "../common.css";
import "./Herosection.css";
import Formsection from "../form/Formsection";
import { FiArrowUpRight } from "react-icons/fi";

export default function Herosection() {
  return (
    <div className="herosection">
      <div className="top wrapper">
        <img src={logo} alt="error" />
        {/* <button>Contact us</button> */}
      </div>
      <div className="bottom wrapper">
        <div className="left">
          <h1>
            <span>Brokers,</span> Meet Your Complete Real Estate Growth Engine!
          </h1>
          <h3>Your Listings, Our Platform, Faster Closures</h3>
          <p>
            Over 5,000 properties have already been sold through our AI-enabled
            real estate platform. Upload your properties, create your own app &
            share it to reach verified buyers instantly.{" "}
          </p>
          {/* <button>
            Start Closing Faster
            <FiArrowUpRight style={{ marginLeft: "8px" }} />
          </button> */}
        </div>
        <div className="right">
          <Formsection />
        </div>
        <div className="building"><img src={building}/></div>
      </div>
    </div>
  );
}
